/**
 * Runtime events module gate (business_info.events_enabled).
 */
export function isEventsFeatureActive (businessInfo) {
  return !!businessInfo?.events_enabled
}
